import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default class Home extends Component {
	constructor() {
      super();
			this.state={
        currentSlide: 0
      }
	}

	componentDidMount() {
		// Auto-advance slider every 5 seconds
		this.sliderInterval = setInterval(() => {
			this.setState(prevState => ({
				currentSlide: (prevState.currentSlide + 1) % 3
			}));
		}, 5000);
	}

	componentWillUnmount() {
		if (this.sliderInterval) {
			clearInterval(this.sliderInterval);
		}
	}

	goToSlide = (slideIndex) => {
		this.setState({ currentSlide: slideIndex });
	}

	render() {
		const slides = [
			{
				image: "/images/slider-1.jpg",
				overlay: {
					title: "Pacific Coast Garage Doors",
					phone: "(650) 255-4768"
				}
			},
			{
				image: "/images/slider-2.jpg",
				overlay: {
					title: "Quality Garage Door Service",
					phone: "(650) 255-4768"
				}
			},
			{
				image: "/images/slider-3.jpg",
				overlay: {
					title: "Free Estimates Available",
					phone: "(650) 255-4768"
				}
			}
		];

		return (
          <div style={{paddingBottom: "80px"}}>
            <Helmet>
                <title>Pacific Coast Garage Door - Home</title>
                <meta name="description" content="Pacific Coast Garage Door - Located in Half Moon Bay, CA family-owned and operated and servicing the entire bay area. We offer free estimates for all our garage door installations and a 100% guarantee on all of our installations, repairs, and products." />
            </Helmet>
            
            <style jsx>{`
                @media (max-width: 768px) {
                    .yelp-icon {
                        width: 25px !important;
                        height: 25px !important;
                    }
                    .overlay-box {
                        position: absolute !important;
                        top: 50% !important;
                        left: 50% !important;
                        right: auto !important;
                        transform: translate(-50%, -50%) !important;
                        width: 90% !important;
                        max-width: 350px !important;
                    }
                }
            `}</style>
            {/* Hero Slider */}
            <div id="slider" style={{position: "relative", height: "60vh", overflow: "hidden"}}>
              {slides.map((slide, index) => (
                <div 
                  key={index}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url('${slide.image}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: this.state.currentSlide === index ? 1 : 0,
                    transition: "opacity 1s ease-in-out"
                  }}
                >
                  {/* Yelp Banner - Top Left Corner */}
                  <div style={{
                    position: "absolute",
                    left: "20px",
                    top: "20px",
                    zIndex: 100
                  }}>
                    <div className="yelp-background" style={{
                      padding: "20px 15px",
                      borderRadius: "8px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
                    }}>
                      <img src="/images/yelp-logo.png" alt="Yelp" style={{
                        width: "40px",
                        height: "40px",
                        marginBottom: "10px"
                      }} className="yelp-icon" />
                      <div className="white" style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginBottom: "5px"
                      }}>
                        5 Star Reviews
                      </div>
                      <div style={{textAlign: "center"}}>
                        {[...Array(5)].map((_, i) => (
                          <span key={i} style={{color: "#fff", fontSize: "16px"}}>★</span>
                        ))}
                      </div>
                    </div>
                  </div>

                                    {/* Overlay Box - Right Side on Desktop, Centered on Mobile */}
                  <div className="primary-background small-padding white overlay-box" style={{
                    position: "absolute",
                    top: "50%",
                    right: "10%",
                    transform: "translateY(-50%)",
                    width: "400px",
                    zIndex: 1,
                    opacity: 0.95,
                    borderRadius: "8px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
                  }}>
                    <h1 className="white thin centered-text" style={{margin: "0 0 10px 0", fontSize: "2.2em", textAlign: "center"}}>
                        {slide.overlay.title}
                    </h1>
                    <h4 className="white centered-text" style={{margin: "0", fontSize: "1.5em", fontWeight: "bold", textAlign: "center"}}>
                        {slide.overlay.phone}
                    </h4>
                  </div>
                </div>
              ))}
              
              {/* Slider Navigation Dots */}
              <div style={{
                position: "absolute",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 3,
                display: "flex",
                gap: "10px"
              }}>
                {slides.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => this.goToSlide(index)}
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      border: "none",
                      backgroundColor: this.state.currentSlide === index ? "#FF5722" : "rgba(255,255,255,0.5)",
                      cursor: "pointer",
                      transition: "background-color 0.3s ease"
                    }}
                  />
                ))}
              </div>
            </div>

            {/* Main Content */}
            <div className="row white-background">
              <div className="small-12 max-width-container centered-text medium-padding">
                <h2 className="primary-color centered-text" style={{fontSize: "2.2em", marginBottom: "20px"}}>Pacific Coast Garage Doors</h2>
                <p className="margin-top small-margin-bottom subheading">
                  At Pacific Coast Garage Doors our top priority is your satisfaction. We offer free estimates for all our garage door installations and are so confident in the quality of our workmanship that we offer a 100% guarantee on all of our installations, repairs, and products. Contact us today to see what we can do for you!
                </p>
                <p className="primary-color" style={{marginTop: "20px", lineHeight: "2"}}><b>
                  Full warranty on all products and services<br />
                  Family-owned and operated<br />
                  Courteous, professional, and experienced<br />
                  24-hour emergency service<br />
                  Licensed, insured, and bonded
                </b></p>
                <Link to="/portfolio">
                  <div className="button accent-background white medium-margin-top" style={{backgroundColor: "#FF5722", color: "#fff", borderRadius: "4px", marginTop: "40px"}}>View Our Portfolio</div>
                </Link>
              </div>
            </div>

            {/* Portfolio Preview Grid */}
            <div className="white-background centered-text">
              <div className="row tiny-padding" style={{padding: "1vh"}}>
                <div className="small-12 medium-6 background-image-fill" style={{backgroundImage: "url('/images/portfolio-1.jpg')", height: "81vh", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                <div className="small-12 medium-6">
                  <div className="row">
                    <div className="small-6 medium-6 tiny-padding no-right-padding no-top-padding" style={{padding: "1vh"}}>
                      <div className="background-image-fill" style={{backgroundImage: "url('/images/portfolio-2.jpg')", height: "40vh", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                    </div>
                    <div className="small-6 medium-6 tiny-padding no-right-padding no-top-padding" style={{padding: "1vh"}}>
                      <div className="background-image-fill" style={{backgroundImage: "url('/images/portfolio-3.jpg')", height: "40vh", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="small-6 medium-6 tiny-padding no-right-padding no-top-padding no-bottom-padding" style={{padding: "1vh"}}>
                      <div className="background-image-fill" style={{backgroundImage: "url('/images/portfolio-4.jpg')", height: "40vh", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                    </div>
                    <div className="small-6 medium-6 tiny-padding no-right-padding no-top-padding no-bottom-padding" style={{padding: "1vh"}}>
                      <div className="background-image-fill" style={{backgroundImage: "url('/images/portfolio-5.jpg')", height: "40vh", backgroundSize: "cover", backgroundPosition: "center"}}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Areas */}
            <div className="primary-background large-padding centered-text">
              <h4 className="white">Garage Door Specialist</h4>
              <p className="white subheading" style={{marginBottom: "20px"}}>Serving the following cities and surrounding areas</p>
              <div className="row white">
                <div className="small-12 medium-4 white">
                  <p className="white"><b>Pacifica</b></p>
                  <p className="white subheading">Montera</p>
                  <p className="white subheading">Rockaway Beach</p>
                  <p className="white subheading">Sharp Park</p>
                  <p className="white subheading">Loma Mar</p>
                </div>
                <div className="small-12 medium-4 white">
                  <p className="white"><b>Half Moon Bay</b></p>
                  <p className="white subheading">Moss Beach</p>
                  <p className="white subheading">El Granada</p>
                  <p className="white subheading">Miramar</p>
                  <p className="white subheading">Pescadero</p>
                  <p className="white subheading">San Gregorio</p>
                  <p className="white subheading">La Honda</p>
                  <p className="white subheading">Loma Mar</p>
                </div>
                <div className="small-12 medium-4 white">
                  <p className="white"><b>South San Francisco</b></p>
                  <p className="white subheading">Serramonte</p>
                  <p className="white subheading">Westlake</p>
                  <p className="white subheading">Colma</p>
                  <p className="white subheading">Avalon</p>
                </div>
              </div>
            </div>
          </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/home/index.js